// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2U21U","productName":"Table_productName__2D-K4"};